import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    font-size: ${theme.font.size6};

    border: 1px solid #3A3E40;
`;

export const Label = styled.div`
    font-weight: bold;
    margin: 0 10px;
    font-size: ${theme.font.size6};
    color: #868888;
    white-space: nowrap;
`;
